import { render, staticRenderFns } from "./NotificacionesContratos.vue?vue&type=template&id=b3ce862c&scoped=true"
import script from "./NotificacionesContratos.vue?vue&type=script&lang=js"
export * from "./NotificacionesContratos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ce862c",
  null
  
)

export default component.exports